import { useQuery } from "@tanstack/react-query";
import { getGnbMenu } from "src/api/home";
import { DEFAULT_TEACHER_SUBJECT, useHomeSwitchStore } from "src/store/homeSwitch.store";
import { QUERY_KEYS } from "../constants/queryKeys";
/**
 * GNB 메뉴 데이터 조회 쿼리
 * - homeSwitch store의 homeType, subject를 사용하여 API 호출
 * - subject가 유효하지 않을 때 fallbackSubject로 대체하여 탭 목록 보장
 * - 상태 관리는 useGNBMenu 훅에서 담당
 */ const useGetGnbMenu = ()=>{
    const { homeType , subject  } = useHomeSwitchStore();
    return useQuery({
        queryKey: [
            QUERY_KEYS.GNB_MENU,
            homeType,
            subject
        ],
        queryFn: ()=>getGnbMenu({
                type: homeType,
                subject,
                fallbackSubject: DEFAULT_TEACHER_SUBJECT
            })
    });
};
export default useGetGnbMenu;
